import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { jsx as t } from "react/jsx-runtime";
import { withVDSManager as e, generateUUID as o } from "@vds-core/utilities";
import { Component as i, Children as n, Fragment as r, cloneElement as c } from "react";
import p from "styled-components";
var s = p.div.withConfig({
    displayName: "AccordionWrapper",
    componentId: "VDS__sc-1t8ffc4-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n"]))),
  d = p.div.withConfig({
    displayName: "AccordionList",
    componentId: "VDS__sc-1t8ffc4-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%; /* Necessary so component takes full width of parent component */\n"])));
var a = /*#__PURE__*/function (_i) {
  _inherits(a, _i);
  function a(t) {
    var _this;
    _classCallCheck(this, a);
    var e;
    _this = _possibleConstructorReturn(this, _getPrototypeOf(a).call(this, t)), e = _assertThisInitialized(_assertThisInitialized(_this)), _this.updateActiveAccordion = function (t) {
      e.setState({
        activeID: t
      }), "undefined" != typeof window && (window.scrollBy(0, 1), window.scrollBy(0, -1));
    }, _this._getTopLine = function (t) {
      var o = e.props.topLine;
      return !!o || 0 !== t;
    }, _this.idPrefix = o(), _this.state = {
      activeID: null
    };
    return _this;
  }
  _createClass(a, [{
    key: "render",
    value: function render() {
      var e = this;
      var _this$props = this.props,
        o = _this$props.children,
        i = _this$props.surface,
        p = _this$props.type,
        a = _this$props.testMode,
        l = _this$props.id,
        f = _this$props.viewport,
        u = _this$props.bottomLine;
      var m = 0;
      return t(s, {
        children: t(d, {
          id: l,
          children: n.map(o, function (t, s) {
            var d = t;
            if (!d || "boolean" == typeof d) return null;
            var l = n.toArray(o).length;
            var y = d.type === r ? d.props.children : d;
            y = y instanceof Array ? y[0] : y;
            return "AccordionItem" === (y.type && y.type.componentType ? y.type.componentType : "") ? c(y, {
              key: s + 1,
              activeID: e.state.activeID,
              onClick: e.updateActiveAccordion,
              groupIndex: m,
              groupId: "".concat(e.idPrefix, "_").concat(m++),
              surface: i,
              clickHandler: e.updateActiveAccordion,
              type: p,
              testMode: a,
              viewport: f,
              topLine: e._getTopLine(s),
              bottomLine: u && s === l - 1
            }) : d;
          })
        })
      });
    }
  }]);
  return a;
}(i);
a.defaultProps = {
  surface: "light",
  type: "multi",
  testMode: !1,
  topLine: !1,
  bottomLine: !0
};
var l = e(a);
export { l as default };